import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import { Layout } from '../../components/Layout'
import { Context } from '../../Context'
import { GLOBALS } from '../../utils/Globals'
import { SchedulerService } from '../../services/Scheduler'
import './styles.scss'

export const Reserve = () => {
  const { isAuth: token, userLogged } = useContext(Context)
  const [isLoading, setIsLoading] = useState(false)
  const [reserves, setReserves] = useState([])
  const [, setError] = useState(null)

  useEffect(() => {
    const fetchReserves = async () => {
      setIsLoading(true)
      setError(null)

      try {
        let reserves = []

        if (userLogged.role === 'U' || userLogged.role === 'T') {
          const response = await SchedulerService.getMyHistory(token)

          if (response) {
            if (response.rows && Array.isArray(response.rows)) {
              reserves = response.rows
            } else if (Array.isArray(response)) {
              reserves = response
            } else if (response.data && Array.isArray(response.data)) {
              reserves = response.data
            }
          }
        }

        setReserves(reserves)
      } catch (error) {
        console.error('Error al cargar reservas:', error)
        setError('Hubo un error al cargar las reservas')
        setReserves([])
      } finally {
        setIsLoading(false)
      }
    }

    if (token) {
      fetchReserves()
    }
  }, [userLogged.id, token, userLogged.role])

  const config = {
    title: 'Mis reservas',
    icon: GLOBALS.menu.reserve.icon,
    backlink: GLOBALS.menu.reserve.link,
  }

  const isActive = (startDate, endDate) => {
    // Get current time
    const now = new Date()

    // Convert UTC dates to local time
    const start = new Date(startDate)
    const end = new Date(endDate)

    const isAfterStart = now >= start
    const isBeforeEnd = now <= end
    const isActive = isAfterStart && isBeforeEnd

    return isActive
  }

  const cancelReserve = async (id) => {
    try {
      setIsLoading(true)
      await SchedulerService.delete(id, token)

      setReserves((prevReserves) => {
        const updatedReserves = prevReserves.filter((reserve) => {
          const shouldKeep = !(reserve.id === id)
          return shouldKeep
        })
        return updatedReserves
      })
    } catch (error) {
      console.error('Error detallado al cancelar reserva:', error)
      setError('Hubo un error al cancelar la reserva')
    } finally {
      setIsLoading(false)
    }
  }

  const validateCancelReserve = (reserve) => {
    let jsx
    const startDate = new Date(reserve.startDate)
    const currentDate = new Date()
    if (currentDate < startDate) {
      if (reserve) {
        jsx = (
          <button
            className="cancel-button"
            onClick={() => cancelReserve(reserve.id)}
            disabled={isLoading}
          >
            Cancelar Reserva
          </button>
        )
      } else {
        jsx = <></>
      }
    }
    return jsx
  }

  return (
    <Layout>
      <>
        {isLoading ? (
          <div className="loading-container">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: '3em' }}></i>
          </div>
        ) : (
          <div className="reserves-container">
            <div className="header">
              <h1>
                {config.icon && <i className={config.icon}></i>}
                {config.title}
              </h1>
            </div>

            <div className="reserves-list">
              {reserves.length === 0 ? (
                <p className="notReserves">No se encontraron reservas activas</p>
              ) : (
                reserves.map((reserve, index) => (
                  <div
                    key={`${reserve.laboratory_id}-${reserve.pod_id}-${index}`}
                    className={`reserve-item ${
                      isActive(reserve.startDate, reserve.endDate) ? 'active' : 'inactive'
                    }`}
                  >
                    <div className="reserve-info">
                      <p>
                        <strong>ID de Reserva:</strong> {reserve.id}
                      </p>
                      <p>
                        <strong>Laboratorio:</strong> {reserve.laboratory.name}
                      </p>
                      <p>
                        <strong>Fecha de inicio:</strong>{' '}
                        {new Date(reserve.startDate).toLocaleString()}
                      </p>
                      <p>
                        <strong>Fecha de fin:</strong> {new Date(reserve.endDate).toLocaleString()}
                      </p>
                    </div>
                    <div className="reserve-actions">
                      {isActive(reserve.startDate, reserve.endDate) ? (
                        <Link to={`/viewlaboratory/${reserve.laboratory_id}`}>
                          <button className="view-button">Ver Laboratorio</button>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {validateCancelReserve(reserve)}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </>
    </Layout>
  )
}
